import type { PaymentTier } from '@mondy/shared';

type TierBadgeSize = 'xs' | 'sm' | 'md';

const SIZE_PX: Record<TierBadgeSize, number> = {
  xs: 10,
  sm: 12,
  md: 16,
};

const TIER_COLORS: Record<
  Exclude<PaymentTier, 'free'>,
  { stroke: string; fill: string; label: string }
> = {
  silver: { stroke: '#94A3B8', fill: '#CBD5E1', label: 'Silver' },
  gold: { stroke: '#B45309', fill: '#F5C842', label: 'Gold' },
  platinum: { stroke: '#0E7490', fill: '#7DD3FC', label: 'Platinum' },
};

export function TierBadge({
  tier,
  size = 'sm',
}: {
  tier: PaymentTier;
  size?: TierBadgeSize;
}) {
  if (tier === 'free') return null;
  const colors = TIER_COLORS[tier];
  if (!colors) return null;
  const px = SIZE_PX[size];
  return (
    <svg
      role="img"
      aria-label={`${colors.label} tier`}
      width={px}
      height={px}
      viewBox="0 0 24 24"
      fill={colors.fill}
      stroke={colors.stroke}
      strokeWidth={1.5}
      strokeLinejoin="round"
      style={{ flexShrink: 0, display: 'inline-block', verticalAlign: 'middle' }}
    >
      <title>{`${colors.label} tier`}</title>
      <path d="M12 2.5l2.9 5.88 6.49.94-4.7 4.58 1.11 6.46L12 17.32l-5.8 3.04 1.11-6.46-4.7-4.58 6.49-.94L12 2.5z" />
    </svg>
  );
}
